import parse from 'html-react-parser';

import { Box, BoxProps, Heading } from '@chakra-ui/react';

import { Text } from 'ui';

interface AuthHeaderProps extends BoxProps {
  title: string;
  subtitle?: string;
  color: string;
}

const AuthHeader = ({ title, subtitle, color, ...props }: AuthHeaderProps) => (
  <Box {...props}>
    <Heading
      textStyle='h1'
      as='h1'
      textAlign='center'
      mb={{ base: '20px', md: '35px' }}
      fontWeight='semibold'
      color={color}
      fontSize={[24, 28, 32]}
    >
      {title}
    </Heading>

    {Boolean(subtitle) && (
      <Text textAlign='center' fontSize={{ base: 14, md: 16 }} color={color}>
        {parse(subtitle ?? '')}
      </Text>
    )}
  </Box>
);

export default AuthHeader;
